import React from 'react'
import AdxSortTable from 'components/reusable/table/AdxSortTable'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Icon from '@mui/material/Icon'
import StatusBar from 'components/reusable/statusBar/AdxStatusBar'
import { useLocation, useNavigate } from 'react-router-dom'
import { useQuery } from 'react-query'
import { getQueryReports } from 'services/api/modules/claim/report'
import reportStatusConverter from 'module/claim/services/helper/reportStatusConverter'
import { ReportIconConstructor } from '../../functions'
import { Skeleton } from '@mui/material'
import capitalizeFirstWord from 'services/helper/capitalizeFirstWord'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'
import { Clear } from '@mui/icons-material'

const ReimbursementReportTable = () => {
  const reimbursementReportColumn = [
    {
      Header: 'Claim reports',
      accessor: 'claimReport',
      Cell: (props) => {
        const { claim_report_type, title, start_date, end_date } = props.row.original
        return isLoading ? (
          <Box display="flex" alignItems="center" height="50px">
            <Skeleton variant="text" width={300} />
          </Box>
        ) : (
          <Box
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'center'}
            columnGap={3}
          >
            <Box display="flex" alignItems="center" columnGap={2}>
              <Box
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                width={50}
                height={50}
                bgcolor="alternate.light"
                borderRadius={'50%'}
              >
                <Icon sx={{ fontSize: 25, color: 'alternate.main' }}>
                  {ReportIconConstructor(claim_report_type)}
                </Icon>
              </Box>
              <Box>
                <Typography
                  width={{
                    xs: 'calc(100vw - 400px)',
                    lg: 'calc(100vw - 1200px)',
                  }}
                  minWidth={{ xs: 1, lg: '200px' }}
                  noWrap
                  variant="body1"
                  color="dark-text.main "
                >
                  {capitalizeFirstWord(title)}
                </Typography>
                <Box display={'flex'} alignItems={'center'} columnGap={1.5}>
                  <Typography
                    noWrap
                    component="span"
                    variant="body2"
                    color="light-gray-text.main"
                    textTransform="capitalize"
                  >
                    {claim_report_type}
                  </Typography>
                  <Icon sx={{ fontSize: 7, color: 'light-gray-text.main' }}>circle_rounded</Icon>
                  <Typography
                    noWrap
                    component="span"
                    variant="body2"
                    color="light-gray-text.main"
                    textTransform="capitalize"
                  >
                    {start_date} - {end_date}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        )
      },
    },
    {
      Header: 'Expense amount',
      accessor: 'totalAmount',
      Cell: (props) => {
        const { amount_total, expenses } = props.row.original
        return isLoading ? (
          <Box display="flex" alignItems="center" height="50px">
            <Skeleton variant="text" width={200} />
          </Box>
        ) : (
          <Box display={'flex'} flexDirection="column" justifyContent="center" rowGap={0.5}>
            <Typography
              align="start"
              variant="body1"
              color="light-gray-text.main"
              fontWeight="bold"
            >
              RM {parseFloat(amount_total).toFixed(2)}
            </Typography>
            {/* <Typography
              align="center"
              variant="body2"
              color="light-gray-text.main"
            >
              ({expenses?.length}{" "}
              {expenses?.length > 1 ? "expenses" : "expense"})
            </Typography> */}
          </Box>
        )
      },
    },
    {
      Header: 'Reimbursement',
      accessor: 'reimbursedAmount',
      Cell: (props) => {
        const { amount_payable, report_status } = props.row.original

        return isLoading ? (
          <Box display="flex" alignItems="center" height="50px">
            <Skeleton variant="text" width={200} />
          </Box>
        ) : (
          <Box display={'flex'} justifyContent="start" alignItems={'center'} columnGap={2}>
            <StatusBar status={reportStatusConverter(report_status?.name)} />

            <Typography
              noWrap
              variant="body1"
              color="dark-text.main"
              fontWeight="bold"
              component="span"
              mr={3}
            >
              RM {parseFloat(amount_payable).toFixed(2)}
            </Typography>
          </Box>
        )
      },
    },
  ]
  // API CALL
  const { isLoading, data } = useQuery('ReimbursementReportsData', async () => {
    const { data } = await getQueryReports({ status: 'pending reimbursement' })
    return data?.reports
  })

  const navigate = useNavigate()
  const location = useLocation()
  const handleNavigate = (id) => {
    navigate(`../reports/${id}`, { state: { currentLocation: location } })
  }

  return (
    <>
      {!isLoading && data?.length === 0 ? (
        <AdxEmptyStateV2 icon={<Clear />} title="No awaiting reimbursement reports" />
      ) : (
        <AdxSortTable
          stickyHeader
          height="calc(100vh - 243px)"
          column={reimbursementReportColumn}
          data={data ? data : ['', '', '']}
          nav={
            isLoading ? (
              <Box display="flex" alignItems="center" height="50px">
                <Skeleton variant="text" width={100} />
              </Box>
            ) : (
              <Typography
                variant="body1"
                color="alternate.main"
                mr={1}
                sx={{ textDecoration: 'underline', cursor: 'pointer' }}
              >
                View
              </Typography>
            )
          }
          onClick={(e) => handleNavigate(e.id)}
        />
      )}
    </>
  )
}

export default ReimbursementReportTable
